import { render, staticRenderFns } from "./ReturnItems.vue?vue&type=template&id=44d7ccbd&"
import script from "./ReturnItems.vue?vue&type=script&lang=js&"
export * from "./ReturnItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports